<script>
import axios from '@/utils/axios';
import { allUsers } from '@/utils/user';
import units from "@/assets/json/units.json";
import { byDocumentType } from '@/utils/document-setting';
import { documentTemplates } from '@/utils/document-template';
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { downloadPDF as downloadPDFUtil } from '@/utils/pdf-download';
import DocumentPlaceholder from '@/components/common/proforma-placeholder.vue';
import { useCountryStore } from '@/stores/useCountryStore';
import { useStatesStore } from '@/stores/useStatesStore';

export default {
  components: {
   DocumentPlaceholder  
  },
  inject: ['setLoading'],
  data() {
    return {
      id: '',
      ids: [],
      errors: {},
      quotation_id: null,
      modal_title: '',
      to_name: '',
      to_email: '',
      to_phone: '',
      to_address: '',
      to_city: '',
      gst_no: '',
      to_pincode: '',
      to_state: null,
      to_country: null,
      to_shipping_name: '',
      to_shipping_email: '',
      to_shipping_phone: '',
      to_shipping_address: '',
      to_shipping_city: '',
      sales_person_id: null,
      to_shipping_pincode: '',
      to_shipping_state: null,
      to_shipping_country: null,
      selectedParty: null,
      status: null,
      tax_mode: null,
      selectedTax: null,
      selectedUnit: null,
      issue_date: '',
      due_date: '',
      po_number: '',
      po_date: '',
      vendor_number: '',
      vehicle_number: '',
      notes: '',
      tax_modes: ['Item', 'Invoice'],
      place_of_supply: '',
      countries: [],
      taxes: [],
      parties: [],
      allItems: [],
      items: [
        { item: null, description: '', unit: '', hsn_code: '', price: 0, qty: 1, amount: 0 }
      ],
      installation_cost: 0,
      transportation_cost: 0,
      advance_amount: 0,
      discount: 0,
      states: [],
      shipping_states: [],
      loading: false,
      editorConfig: {
        toolbar: {
        items: ['bold', 'italic']
      },
      // 🔧 RESIZEOBSERVER FIX
      resize_enabled: false, 
      resize_image: {
        resizeOptions: [
          { name: 'resize-original', label: 'Original', value: null }
        ]
      }
      },
      editor: ClassicEditor,
      action: '',
      currency: '',
      mass_delete: false,
      party_type: '',
      activities: [],
      remark: '',
      users: [],
      user_id: null,
      units: units,
      assignment_history: [],
      is_shipping: false,
      previewData: null,
      type: "proforma_invoice",
      settings: {
       mail_subject: '',
       mail_body: '',
       mail_footer: '',
       terms: '',
       send_on_email: false,
      },
      templates: [],
      template: null,
      document_template_id: null,
      should_send_mail: false,
      subject: '',
      transport_name: '',
      transport_phone: '',
      customer_usage: '',
    };
  },

  computed: {
   totalAmount(){
    return this.items.reduce((sum, row) => sum + row.amount, 0);
   },

   taxAmount() {
    if(this.tax_mode === 'Invoice'){
     const tax_rate = this.selectedTax?.rate || 0;
     const taxable_amount = this.totalAmount - this.discount;
     return (taxable_amount * tax_rate) / 100;
    }else{
     // Item mode - sum taxes from individual items using selectedTax
     return this.items.reduce((sum, row) => {
      const itemTaxRate = row.selectedTax?.rate || 0;
      return sum + (row.amount * itemTaxRate / 100);
     }, 0);
    }
   },

   grandTotal(){
    const discountAmount = parseFloat(this.discount) || 0;
    const installationAmount = parseFloat(this.installation_cost) || 0;
    const transaportationAmount = parseFloat(this.transportation_cost) || 0;
    return Math.max(0, this.totalAmount - discountAmount) + this.taxAmount + transaportationAmount + installationAmount;
   },

   balanceAmount(){
    let advance_amount = parseFloat(this.advance_amount) || 0;
    if(advance_amount < 0){
     this.advance_amount = 0;
     advance_amount = 0;
    }
    if(advance_amount > this.grandTotal){
     return 0;
    }
    return this.grandTotal - advance_amount;
   },

   showTaxInfo(){
    return !(this.tax_mode === 'Item' && this.clientSetting?.tax_type === 'inclusive');
   }

  },

  // mounted(){  
  //  this.getCountries();
  // },

  watch:{
   
   discount(newVal){
    if (this.totalAmount === 0 || !this.totalAmount) return;
    if(newVal < 0){
     this.discount = 0;
     this.$swalToast("Discount cannot be negative", 'warning');
    }else if(newVal > this.totalAmount){
     this.discount = this.totalAmount;
     this.$swalToast("Discount cannot exceed total amount", 'warning');
    }
   },

   party_type(newVal, oldVal){
    if(newVal !== oldVal && !this.id){
     // Clear selected party and party_id if type changed
      this.selectedParty = null;
     // If you store party_id separately:
      this.party_id = null;
     // Also clear parties array if you want
      this.parties = [];
    }
   },

  },

 methods: {
  add(){
   this.resetForm();
   this.getCountries();
   this.getTaxes();
   this.getUsers();
   this.getAllItems();
   this.byType(this.type);
   this.allDocumentTemplates();
   this.tax_mode = 'Item';
   this.issue_date = this.$currentDate();
   this.due_date = this.$currentDate(7);
   this.summary = this.clientAdmin?.company?.summary || '';
   this.party_type = `App\\Models\\Lead`;
  }, 

  setDefaultSalesPerson(){
   const meInUsers = this.users.find(u => u.id === this.auth?.id);
   if(meInUsers){
    this.sales_person_id = meInUsers.id;
   }
  },

  async getUsers(){
   try{
    const response = await allUsers();
    this.users = response.data.data;
    if(!this.id){
     this.setDefaultSalesPerson(); 
    }
   }catch(error){
    this.$swalToast(error.message, 'error');
   }
  },  

  async allDocumentTemplates(){
   try{
    const response = await documentTemplates(this.type);
    this.templates = response.data.data;
    if(this.id){
     this.template = this.templates.find(t => t.id === this.document_template_id) || null;
    }else{
     // CREATE MODE: Use default document_template_id or first template
     const defaultTemplate = this.templates.find(t => t.id === this.document_template_id) || 
                             (this.templates.length > 0 ? this.templates[0] : null);
     this.template = defaultTemplate;
    }
   }catch(error){
    this.$swalToast(error.message, 'error');
   }finally{
    this.setLoading(false);
   }
  },

  async byType(type){
   this.setLoading(true);
   try{
    const response = await byDocumentType(type, this.clientAdmin?.id);
    const data = response.data.data;
    this.settings = {
     mail_subject: data?.mail_subject || '',
     mail_body: data?.mail_body || '',
     mail_footer: data?.mail_footer || '',
     terms: data?.terms || '',
     send_on_email: data?.send_on_email || false
    };
    this.document_template_id = data?.document_template_id;
   }catch(error){
    this.$swalToast(error.message, 'error');
   }finally{
    this.setLoading(false);
   }
  },

  // async getCountries(){
  //  this.setLoading(true);
  //  try{
  //   const response = await axios.get('/countries');
  //   this.countries = response.data.data;
  //  }catch(error){
  //   this.$swalToast(error.message, 'error');
  //  }finally{
  //   this.setLoading(false);
  //  } 
  // },

  async getCountries(){
  const store = useCountryStore()
  this.countries = await store.loadCountries()
},

  async editProformaInvoice(proforma_invoice_public_token){
   try{
    this.setLoading(true);
    this.getCountries(); 
    this.getTaxes();
    this.getUsers();
    this.byType(this.type);
    this.allDocumentTemplates();
    await this.getAllItems(); 

    const response = await axios.get(`/proforma-invoices/${proforma_invoice_public_token}`);
    const data = response.data.data;

    this.document_template_id = data.document_template_id;

    await this.getPartyById(data.party_type, data.party_id);

    this.id = data.id;
    this.party_type = data.party_type;
    this.to_name = data.to_name;
    this.to_email = data.to_email;
    this.to_phone = data.to_phone;
    this.gst_no = data.gst_no;
    this.to_address = data.to_address;
    this.to_city = data.to_city;
    this.to_pincode = data.to_pincode;
    this.to_country = (data.to_country != '') ? this.countries.find(c => c.name === data.to_country) : null;
    if(this.to_country?.id) await this.onCountrySelect(this.to_country);
    this.to_state = (data.to_state != '') ? this.states.find(s => s.name === data.to_state) : null;
    this.to_shipping_name = data.to_shipping_name;
    this.to_shipping_email = data.to_shipping_email;
    this.to_shipping_phone = data.to_shipping_phone;
    this.to_shipping_address = data.to_shipping_address;
    this.to_shipping_city = data.to_shipping_city;
    this.to_shipping_pincode = data.to_shipping_pincode;
    this.to_shipping_state = (data.to_shipping_state != '') ? this.shipping_states.find(s => s.name === data.to_shipping_state) : null;
    this.to_shipping_country = (data.to_shipping_country != '') ? this.countries.find(c => c.name === data.to_shipping_country) : null;
    this.tax_mode = data.tax_mode;
    this.issue_date = data.issue_date;
    this.due_date = data.due_date;
    this.place_of_supply = data.place_of_supply;
    this.notes = data.notes || '';
    this.settings.terms = data.terms || '';
    this.selectedTax = this.taxes.find(t => t.id === data.tax_id) || null;
    this.discount = parseFloat(data.discount || 0);
    this.installation_cost = parseFloat(data.installation_cost || 0);
    this.transportation_cost = parseFloat(data.transportation_cost || 0);
    this.sales_person_id = data.sales_person_id || null;
    this.subject         = data.subject         || '';
    this.transport_name  = data.transport_name  || '';
    this.transport_phone = data.transport_phone || '';
    this.customer_usage  = data.customer_usage  || '';

    await this.allDocumentTemplates();

    // Populate items
    this.items = data.proforma_items.map(row => {
     const selectedItem = this.allItems.find(i => i.id === row.item_id);
     const unitPrice = parseFloat(row.unit_price || row.price || 0);
     const qty = parseFloat(row.quantity || 1);
     const selectedTax = row.tax_id ? this.taxes.find(t => t.id === row.tax_id) : null;
     const selectedUnit = row.unit ? this.units.find(u => u === row.unit) : null;
      return {
       item: selectedItem || { id: row.item_id, name: row.name },
       selectedTax: selectedTax,
       selectedUnit: selectedUnit,
       description: row.description || '',
       unit: row.unit || '',
       hsn_code: row.hsn_code || '',
       price: unitPrice,
       qty: qty,
       amount: unitPrice * qty
     };
    });

   }catch(error){
    this.$swalToast(error.message, 'error');
   }finally{
    this.setLoading(false);
   }
  },

  async getPartyById(party_type, id){
   try{
    let res;
    if(party_type === `App\\Models\\Lead`){
     res = await axios.get(`/leads/${id}`);
    }else{
     res = await axios.get(`/customers/${id}`);
    }
    this.selectedParty = res.data.data;
    this.onPartySelected(this.selectedParty);
   }catch(err){
    this.$swalToast("Party not found", 'error');
   }
  },

   async getAllItems(){
    try{
     const res = await axios.get('/items/dropdown');
     this.allItems = res.data.data;
    }catch(error){
     this.$swalToast(error.message, 'error');
    }
   },
    
   addItemRow(){
    this.items.push({ item: null, selectedTax: null, selectedUnit: null, description: '', unit: '', hsn_code: '', price: 0, qty: 1, amount: 0 });
   },
   
   removeItemRow(index){
    if (this.items.length === 1) return;
    this.items.splice(index, 1);
   },

   onItemSelected(index, selectedItem){
    const row = this.items[index];
    if(!selectedItem){
     row.item = null;
     row.selectedTax = null;
     row.selectedUnit = null;
     row.description = '';
     row.unit = '';
     row.hsn_code = '';
     row.price = 0;
     row.qty = 1;
     row.amount = 0;
     return;
    }
  
    // Preserve the tax_id from the items table
    row.description = selectedItem.description || '';
    row.unit = selectedItem.unit || '';
    row.hsn_code = selectedItem.hsn_code || '';
    row.price = parseFloat(selectedItem.price || 0);
    row.qty = 1;
  
    // Set the tax for this item if it exists
    if(selectedItem.tax_id){
     row.selectedTax = this.taxes.find(t => t.id === selectedItem.tax_id);
     row.item.tax = row.selectedTax;
    }else{
     row.selectedTax = null;
     row.item.tax = null;
    }

    // Set the unit for this item if it exists (for simple array format)
    if(selectedItem.unit){
     row.selectedUnit = this.units.find(u => u === selectedItem.unit);
    }else{
     row.selectedUnit = null;
    }
  
    this.updateAmount(index);
   },

   updateAmount(index){
    const row = this.items[index];
    row.qty = Math.max(1, parseFloat(row.qty) || 1); 
    const price = parseFloat(row.price) || 0;
    row.amount = row.qty * price;
   },

  //  async onCountrySelect(country){
  //   this.to_state = null;
  //   this.states = [];
  //    if(country?.id){
  //     try{
  //      const response = await axios.get(`/states/${country.id}`);
  //      this.states = response.data.data;
  //     }catch(error){
  //      this.$swalToast(error.message, 'error');
  //     }
  //    }
  //   },

  async onCountrySelect(country){
  this.to_state = null;
  this.states = [];
  if(country?.id){
    const store = useStatesStore()
    this.states = await store.loadStates(country.id)
  }
},

  //  async onShippingCountrySelect(country){
  //   this.to_shipping_state = null;
  //   this.shipping_states = [];
  //   if(country?.id){
  //    try{
  //     const response = await axios.get(`/states/${country.id}`);
  //     this.shipping_states = response.data.data;
  //    }catch(error){
  //     this.$swalToast(error.message, 'error');
  //    }
  //   }
  //  },

async onShippingCountrySelect(country){
  this.to_shipping_state = null;  // ← fix karo
  this.shipping_states = [];
  if(country?.id){
    const store = useStatesStore()
    this.shipping_states = await store.loadStates(country.id)
  }
},

    async onSearch(search){
     if(!search || search.length < 2) return;
     this.loading = true;
     try{
      let res;
      if(this.party_type === "App\\Models\\Lead"){
       res = await axios.get('/leads/dropdown', { params: { search_keyword: search } });
      }else if(this.party_type === "App\\Models\\Customer") {
       res = await axios.get('/customers/dropdown', { params: { search_keyword: search } });
      }
      this.parties = res.data.data;
     }catch(error){
      this.$swalToast(error.message, 'error');
     }finally{
      this.loading = false;
     }
    },

   async onPartySelected(row){
     this.to_email = row?.email || '';
     this.to_phone = row?.mobile || '';
     this.gst_no = row?.gst_no || '';
     this.to_name = row?.company_name || row?.name;
     this.to_address = row?.address || '';
     this.to_city = row?.city || '';
     this.to_pincode = row?.pincode || '';
     if(row?.country !== '' || row?.country !== null){
      this.to_country = this.countries.find(c => c.name === row?.country);
      await this.onCountrySelect(this.to_country);
     }
     this.to_state = (row?.state != '') ? this.states.find(s => s.name === row?.state) : null;
     this.to_shipping_email = row?.email || '';
     this.to_shipping_phone = row?.mobile || '';
     this.to_shipping_name =  row?.name || row?.company_name;
     this.to_shipping_address = row?.shipping_address || '';
     this.to_shipping_city = row?.shipping_city || '';
     this.to_shipping_pincode = row?.shipping_pincode || '';
     if(row?.country !== '' || row?.country !== null){
      this.to_shipping_country = this.countries.find(c => c.name === row?.country);
      await this.onShippingCountrySelect(this.to_shipping_country);
     }
     this.to_shipping_state = (row?.state != '') ? this.shipping_states.find(s => s.name === row?.state) : null;
     this.currency = row?.currency?.code || '';
    },

    async getTaxes(){
     this.setLoading(true);
     try{
      const response = await axios.get('/taxes');
      this.taxes = response.data.data;
     }catch(error){
      this.$swalToast(error.message, 'error');
     }finally{
      this.setLoading(false);
     }
    },

    async submitProformaInvoice(shouldDownload = false) {
     this.setLoading(true);
     this.errors = {};
      try{
       const payload = {
        subject: this.subject,           
        transport_name: this.transport_name,   
        transport_phone: this.transport_phone, 
        customer_usage: this.customer_usage,
        party_type: this.party_type,
        party_id: this.selectedParty?.id,
        quotation_id: this.quotation_id,
        to_name: this.to_name,
        to_email: this.to_email,
        to_phone: this.to_phone,
        gst_no: this.gst_no,
        to_address: this.to_address,
        to_city: this.to_city,
        to_pincode: this.to_pincode,
        to_state: this.to_state?.name,
        to_country: this.to_country?.name,
        to_shipping_name: this.to_name,
        to_shipping_email: this.to_email,
        to_shipping_phone: this.to_phone,
        to_shipping_address: this.to_shipping_address,
        to_shipping_city: this.to_shipping_city,
        to_shipping_pincode: this.to_shipping_pincode,
        to_shipping_state: this.to_shipping_state?.name,
        to_shipping_country: this.to_shipping_country?.name,
        is_shipping: this.is_shipping,
        place_of_supply: this.place_of_supply, 
        issue_date: this.issue_date,
        due_date: this.due_date,
        sales_person_id: this.sales_person_id || null,
        document_template_id: this.template?.id || null,
        po_number: this.po_number,
        po_date: this.po_date,
        vendor_number: this.vendor_number,
        vehicle_number: this.vehicle_number,
        terms: this.settings.terms,
        notes: this.notes,
        tax_mode: this.tax_mode,
        tax_id: this.selectedTax?.id || null,
        discount: this.discount,
        advance_amount: this.advance_amount,
        installation_cost: this.installation_cost,
        transportation_cost: this.transportation_cost,
        items: this.items.map(row => ({
         item_id: row.item?.id || null,
         name: row.item?.name,
         description: row.description,
         unit: row.unit,
         hsn_code: row.hsn_code === 'null' || row.hsn_code === '' || row.hsn_code == null ? null : row.hsn_code,
         quantity: row.qty,
         unit_price: row.price,
         tax_id: row.selectedTax?.id || null
        }))
       };

       let response;
       if(this.id){
        response = await axios.put(`/proforma-invoices/${this.id}/update`, payload);
       }else{
        response = await axios.post('/proforma-invoices/create', payload);
       }

       this.$swalToast(response.data.message);
       this.$emit('updated');

      // SAVE AND DOWNLOAD TRIGGER 
       if(shouldDownload){
        const proformaId = this.id || response.data.data?.id;
        if(proformaId){
         await downloadPDFUtil('proforma-invoices', proformaId);
        }
       }

       this.$closeModal('proforma_invoice_modal');
       this.resetForm();

       // SAVE AND SEND TRIGGER
       if(this.should_send_mail){
        const invoice = response.data.data;
        this.$openModal('proforma_mail_modal');
        this.mailProforma(invoice);
       }

      }catch(error){
       if(error?.type === 'validation'){
        this.errors = error.errors;
       }else{
        this.$swalToast(error.message, 'error');
       }
      }finally{
       this.setLoading(false);
      }
    },

    async deleteProformaInvoice(){
     this.errors = {};
     this.setLoading(true); 
     try{
      const response = await axios.delete(`/proforma-invoices/${this.id}/delete`);
      this.$swalToast(response.data.message);
      this.$emit('updated');
      this.$closeModal('proforma_invoice_delete_modal');
     }catch(error){
      if(error.type == 'validation'){
       this.errors = error.errors;
      }else{
       this.$swalToast(error.message, 'error'); 
      }
     }finally{
      this.setLoading(false);
     }
    },

    getItemError(index, field){
     const key = `items.${index}.${field}`;
     return this.errors[key] ? this.errors[key][0] : null;
    },

    getItemAmountDisplay(item) {
     if(this.tax_mode === 'Item'){
      if(this.clientSetting?.tax_type === 'inclusive'){
       return item.amount;
      }else{
       if(item.item?.tax){
        return item.amount * (1 + (item.item.tax.rate / 100));
       }
       return item.amount;
      }
     }
     return item.amount;
    },

    proformaInvoiceAction(proforma_id, action){
     this.id = proforma_id; 
     this.action = action;
    },

    bulkAction(ids){
     this.ids = ids;
    },

    async submitBulkAction() {
     const result = await this.$confirm({});
     if(result.isConfirmed){
      this.setLoading(true); 
     try{
      const response = await axios.post('/proforma-invoices/bulk-actions', {
       ids: this.ids,
       mass_delete: this.mass_delete,
       status: this.status || '',
      });
      this.$swalToast(response.data.message);
      this.$emit('updated');
      this.$closeModal('bulk_action_proforma_invoice');
     }catch(error){
      this.$swalToast(error.message, 'error');
     }finally{
      this.setLoading(false);
     }
     }
    },

    async activity(id){
     this.setLoading(true);
     try{
      const response = await axios.get(`/proforma-invoices/${id}/activity`);
      this.activities = response.data.data;
     }catch(error){
      this.$swalToast(error.message, 'error');
     }finally{
      this.setLoading(false);
     }
    },

    async getAllUsers(){
     try{
     const response = await axios.get('/users/all-users');
     this.users = response.data.data; 
     }catch(error){
      console.log(error.message);
     } 
    },

    async assignHistory(id, invoice_number){
     this.id = id;
     this.modal_title = invoice_number;
     await this.getAllUsers();
     this.setLoading(true);
     try{
      const response = await axios.get(`/proforma-invoices/${id}/assignment/history`);
      this.assignment_history = response.data.data;
     }catch(error){
      this.$swalToast(error.message, 'error');
     }finally{
      this.setLoading(false);
     }
    },

    async assignProformaInvoice(){
     this.errors = {};
     this.setLoading(true);
     try{
      const payload = {
       user_id: this.user_id,
       remark: this.remark 
      };
      const response = await axios.patch(`/proforma-invoices/${this.id}/assign`, payload);
      this.$swalToast(response.data.message);
      this.$emit('updated');
      this.$closeModal('proforma_invoice_assign_modal');
     }catch(error){
      if(error.type === 'validation'){
       this.errors = error.errors;
      }else{
       this.$swalToast(error.message, 'error');
      }
     }finally{
      this.setLoading(false);
     } 
    },

    createViaParty(party_type, party_id){
     this.add(); 
     this.party_type = party_type;
     this.getPartyById(party_type,party_id);
    },

    async generateByQuotation(public_token){
     try{
      this.setLoading(true);
      // Reset form and initialize required data
      this.resetForm();
      this.getTaxes();
      this.getAllItems();
      this.byType(this.type);
      this.allDocumentTemplates();
    
      // Fetch quotation data
      const response = await axios.get(`/quotations/${public_token}`);
      const data = response.data.data;
    
      // Set quotation reference
      this.quotation_id = data.id;
    
      // Auto-fill client details from quotation party data
      this.party_type = data.party_type;
      this.getPartyById(data.party_type, data.party_id);
    
      // Billing address details
      this.to_name = data.to_name;
      this.to_email = data.to_email;
      this.to_phone = data.to_phone;
      this.gst_no = data.gst_no;
      this.to_address = data.to_address;
      this.to_city = data.to_city;
      this.to_pincode = data.to_pincode;
      this.to_state = (data.to_state != '') ? this.states.find(s => s.name === data.to_state) : null;
      this.to_country = (data.to_country != '') ? this.countries.find(c => c.name === data.to_country) : null;
    
      // Set default dates (issue date as today, due date as 7 days from today)
      this.issue_date = this.$currentDate();
      this.due_date = this.$currentDate(7);
    
      // Tax configuration
      this.tax_mode = data.tax_mode;
      this.selectedTax = data.tax_id ? this.taxes.find(t => t.id === data.tax_id) : null;
      
      // Financial details
      this.discount = parseFloat(data.discount || 0);
      this.installation_cost = parseFloat(data.installation_cost || 0);
      this.transportation_cost = parseFloat(data.transportation_cost || 0);
      
      // Copy terms and notes
      this.settings.terms = data.terms || '';
      this.notes = data.notes || '';
    
      // Place of supply
      this.place_of_supply = data.place_of_supply || '';
    
      // Auto-fill items from quotation
      this.items = data.quotation_items.map(quotationItem => {
        const selectedItem = quotationItem.item;
        const unitPrice = parseFloat(quotationItem.unit_price || quotationItem.item.price || 0);
        const qty = parseFloat(quotationItem.quantity || 1);
        const selectedTax = quotationItem.tax_id ? this.taxes.find(t => t.id === quotationItem.tax_id) : null;
        const selectedUnit = quotationItem.unit ? this.units.find(u => u === quotationItem.unit) : null;
        
        return {
          item: selectedItem || { 
            id: quotationItem.item_id, 
            name: quotationItem.name,
            tax_id: quotationItem.tax_id
          },
          selectedTax: selectedTax,
          selectedUnit: selectedUnit,
          description: quotationItem.description || '',
          unit: quotationItem.unit || '',
          hsn_code: quotationItem.hsn_code || '',
          price: unitPrice,
          qty: qty,
          amount: unitPrice * qty
        };
      });
    
      // Set currency from party data
      this.currency = data.party?.currency?.code || '';
    }catch(error){
     this.$swalToast(error.message || 'Failed to load quotation data', 'error');
    }finally{
     this.setLoading(false);
    }
   },

    preview() {
     this.previewData = {
     to_name: this.to_name,
     to_email: this.to_email,
     to_phone: this.to_phone,
     gst_no: this.gst_no,
     to_address: this.to_address,
     to_city: this.to_city,
     to_pincode: this.to_pincode,
     to_state: this.to_state?.name,
     to_country: this.to_country?.name,
     to_shipping_name: this.to_shipping_name,
     to_shipping_email: this.to_shipping_email,
     to_shipping_phone: this.to_shipping_phone,
     to_shipping_address: this.to_shipping_address,
     to_shipping_city: this.to_shipping_city,
     to_shipping_pincode: this.to_shipping_pincode,
     to_shipping_state: this.to_shipping_state?.name,
     to_shipping_country: this.to_shipping_country?.name,
     issue_date: this.issue_date,
     due_date: this.due_date,
     place_of_supply: this.place_of_supply,
     terms: this.settings.terms,
     notes: this.notes,
     tax_mode: this.tax_mode,
     tax_name: this.selectedTax?.name || null,
     selectedTax: this.selectedTax,
     discount: this.discount,
     installation_cost: this.installation_cost,
     transportation_cost: this.transportation_cost,
     items: this.items.map(item => {
      const baseItem = {
        name: item.item?.name || '',
        description: item.description,
        unit: item.unit,
        hsn_code: item.hsn_code,
        price: item.price,
        qty: item.qty,
        amount: item.amount,
        totalWithTax: item.amount,
        image: item.item?.image || null
      };

      // Add tax calculations if tax_mode is 'Item'
      if(this.tax_mode === 'Item'){
       const taxRate = item.item?.tax?.rate || 0;
       const itemTaxAmount = item.amount * (taxRate / 100); 
       return {
          ...baseItem,
          taxRate: taxRate,
          taxAmount: itemTaxAmount,
          taxName: item.item?.tax?.name || '',
          totalWithTax: item.amount + itemTaxAmount
       };
      }
     return baseItem;
    }),
    totalAmount: this.totalAmount,
    taxAmount: this.taxAmount,
    grandTotal: this.grandTotal,
    currency: this.currency
  };

  // Generate unique ID for this preview
  const previewId = Date.now().toString();
  
  // Store data in sessionStorage
  sessionStorage.setItem(`preview_${previewId}`, JSON.stringify(this.previewData));
  
  // Open in new tab with the preview ID
  const url = this.$router.resolve({
    name: 'preview-proforma-invoice',
    params: { id: previewId }
  }).href;
   window.open(url, '_blank');
  },

   onItemTaxSelected(index, selectedTax){
    const row = this.items[index];
    row.selectedTax = selectedTax;
  
    // Update the item's tax reference for calculations
    if (selectedTax) {
     row.item = row.item || {};
     row.item.tax = selectedTax;
     row.item.tax_id = selectedTax.id;
    } else {
     if (row.item) {
      row.item.tax = null;
      row.item.tax_id = null;
     }
    }
    // Recalculate amount if needed
    this.updateAmount(index);
   },
   
   onItemUnitSelected(index, selectedUnit){
    const row = this.items[index];
    row.selectedUnit = selectedUnit;  
    if(selectedUnit){
     row.unit = selectedUnit;
    }else{
     row.unit = '';
    }
   },

   async save(){
    await this.submitProformaInvoice(false);
   },
  
   async saveAndDownload(){
    await this.submitProformaInvoice(true); 
   },

   async saveAndSend(){
    this.should_send_mail = true;
    await this.submitProformaInvoice(false);
   },
    
    // ##############################
    //  *** MAIL FUNCTIONS START ***
    // ##############################
    
      async mailProforma(row){ 
       this.id = row.id;
       this.modal_title = row.invoice_number;
       this.to_email = row.to_email;
       await this.byType(this.type);
      },
    
      async sendMail(){
       this.errors = {};
       this.setLoading(true);
       try{
        const payload = {
          to_email: this.to_email,
          mail_subject: this.settings.mail_subject,
          mail_body: this.settings.mail_body,
          mail_footer: this.settings.mail_footer
        };
         const response = await axios.post(`/proforma-invoices/${this.id}/email`, payload);
         this.$swalToast(response.data.message);
         this.$emit('updated');
         this.$closeModal('proforma_mail_modal');
         this.resetForm();
        }catch(error){
        if(error.type === 'validation'){
         this.errors = error.errors;
        }else{
         this.$swalToast(error.message, 'error');
        }
        }finally{
         this.setLoading(false);
       } 
      },
    
    // ##############################
    //  *** MAIL FUNCTIONS END ***
    // ##############################

    resetForm() {
     this.id = null;
     this.to_name = '';
     this.to_email = '';
     this.to_phone = '';
     this.gst_no = '';
     this.to_address = '';
     this.to_city = '';
     this.to_pincode = '';
     this.to_state = null;
     this.to_country = null;
     this.to_shipping_name = '';
     this.to_shipping_email = '';
     this.to_shipping_phone = '';
     this.to_shipping_address = '';
     this.to_shipping_city = '';
     this.to_shipping_pincode = '';
     this.to_shipping_state = null;
     this.to_shipping_country = null;
     this.issue_date = '';
     this.due_date = '';
     this.settings.terms = '';
     this.notes = '';
     this.party_type = '';
     this.selectedParty = null;
     this.status = null;
     this.tax_mode = null;
     this.selectedTax = null;
     this.place_of_supply = '';
     this.sales_person_id = null;
     this.items = [{ item: null, selectedTax: null, selectedUnit: null, description: '', unit: '', hsn_code: '', price: 0, qty: 1, amount: 0 }];
     this.discount = 0;
     this.installation_cost = 0;
     this.transportation_cost = 0;
     this.errors = {};
     this.subject         = '';
    this.transport_name  = '';
    this.transport_phone = '';
    this.customer_usage  = '';
    }
  }
};
</script>


<style scoped>
/* ─────────────────────────────────────────────
   PROFORMA INVOICE MODAL — MATCHING QUOTATION UI
───────────────────────────────────────────── */
 
.pf-main { flex: 1; display: flex; flex-direction: column; overflow: hidden; background: #f1f5f9; }
.pf-topbar { background: #fff; border-bottom: 1px solid #e2e8f0; padding: 12px 22px; display: flex; align-items: center; justify-content: space-between; flex-shrink: 0; }
.pf-page-title { font-size: 14px; font-weight: 700; color: #0f172a; }
.pf-page-sub { font-size: 11px; color: #94a3b8; }
.pf-close-btn { width: 30px; height: 30px; border-radius: 7px; background: #f1f5f9; border: 1px solid #ef4444; display: flex; align-items: center; justify-content: center; cursor: pointer; font-size: 13px; transition: all .15s; color: #ef4444; }
.pf-close-btn:hover { background: #fee2e2; border-color: #fca5a5; color: #ef4444; }
.pf-body { flex: 1; overflow-y: auto; padding: 18px 22px; scrollbar-width: thin; scrollbar-color: #cbd5e1 transparent; }
.pf-body::-webkit-scrollbar { width: 4px; }
.pf-body::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 10px; }
.pf-card { background: #fff; border: 1px solid #e2e8f0; border-radius: 12px; margin-bottom: 14px; overflow: visible; }
.pf-card-head { display: flex; align-items: center; gap: 9px; padding: 10px 16px; background: #f8fafc; border-bottom: 1px solid #e8edf3; }
.pf-card-icon { width: 24px; height: 24px; border-radius: 6px; display: flex; align-items: center; justify-content: center; font-size: 12px; flex-shrink: 0; }
.pf-card-title { font-size: 12px; font-weight: 700; color: #0f172a; letter-spacing: .1px; }
.pf-card-body { padding: 14px 16px; }
.pf-label { font-size: 11px; font-weight: 600; color: #475569; margin-bottom: 4px; display: block; }
.pf-label .req { color: #f43f5e; margin-left: 2px; }
.pf-input, .pf-select, .pf-textarea { width: 100%; border: 1.5px solid #e2e8f0; border-radius: 8px; padding: 0 11px; font-size: 12.5px; color: #1e293b; background: #fff; outline: none; transition: border-color .15s, box-shadow .15s; }
.pf-input, .pf-select { height: 35px; }
.pf-textarea { padding: 8px 11px; resize: vertical; }
.pf-input:focus, .pf-select:focus, .pf-textarea:focus { border-color: #3b82f6; box-shadow: 0 0 0 3px rgba(59,130,246,.1); }
.pf-input.err { border-color: #f43f5e; box-shadow: 0 0 0 3px rgba(244,63,94,.1); }
.pf-err-msg { font-size: 10.5px; color: #f43f5e; margin-top: 3px; display: flex; align-items: center; gap: 3px; }
.pf-item-card { background: #fff; border: 1.5px solid #e8edf3; border-radius: 10px; padding: 14px 14px 10px; margin-bottom: 10px; position: relative; transition: border-color .15s, box-shadow .15s; }
.pf-item-card:hover { border-color: #bfdbfe; box-shadow: 0 2px 10px rgba(59,130,246,.07); }
.pf-item-num { position: absolute; top: -9px; left: 14px; width: 19px; height: 19px; background: #3b82f6; color: #fff; border-radius: 50%; font-size: 9px; font-weight: 700; display: flex; align-items: center; justify-content: center; }
.pf-remove-btn { width: 30px; height: 30px; border-radius: 7px; background: #fff0f3; border: 1.5px solid #fecdd3; color: #f43f5e; font-size: 13px; cursor: pointer; display: flex; align-items: center; justify-content: center; transition: all .15s; }
.pf-remove-btn:hover { background: #f43f5e; border-color: #f43f5e; color: #fff; }
.pf-add-item-btn { display: inline-flex; align-items: center; gap: 6px; padding: 7px 14px; background: #eff6ff; border: 1.5px dashed #93c5fd; border-radius: 8px; color: #2563eb; font-size: 11.5px; font-weight: 600; cursor: pointer; transition: all .15s; }
.pf-add-item-btn:hover { background: #dbeafe; border-color: #3b82f6; }
.pf-price-row { display: flex; align-items: center; justify-content: space-between; padding: 7px 0; border-bottom: 1px dashed #f1f5f9; }
.pf-price-row:last-of-type { border-bottom: none; }
.pf-price-label { font-size: 12px; color: #64748b; font-weight: 500; }
.pf-price-val { font-size: 12.5px; font-weight: 700; color: #1e293b; }
.pf-price-input-box { display: flex; align-items: center; border: 1.5px solid #e2e8f0; border-radius: 7px; overflow: hidden; width: 126px; background: #fff; }
.pf-price-prefix { padding: 0 7px; font-size: 10px; font-weight: 600; color: #94a3b8; background: #f8fafc; border-right: 1.5px solid #e2e8f0; height: 30px; display: flex; align-items: center; }
.pf-price-num-input { border: none; outline: none; width: 100%; text-align: right; font-size: 12px; font-weight: 600; color: #1e293b; padding: 0 8px; height: 30px; background: transparent; }
.pf-grand-box { display: flex; align-items: center; justify-content: space-between; background: linear-gradient(135deg,#0f172a,#1e3a5f); border-radius: 10px; padding: 13px 18px; margin-top: 10px; }
.pf-grand-label { font-size: 12.5px; font-weight: 700; color: #93c5fd; display: flex; align-items: center; gap: 6px; }
.pf-grand-val { font-size: 18px; font-weight: 800; color: #fff; letter-spacing: -.5px; }
.pf-balance-box { display: flex; align-items: center; justify-content: space-between; background: linear-gradient(135deg,#7f1d1d,#991b1b); border-radius: 10px; padding: 10px 18px; margin-top: 6px; }
.pf-balance-label { font-size: 12px; font-weight: 700; color: #fca5a5; display: flex; align-items: center; gap: 6px; }
.pf-balance-val { font-size: 16px; font-weight: 800; color: #fff; }
.pf-footer { background: #fff; border-top: 1px solid #e2e8f0; padding: 11px 22px; display: flex; align-items: center; gap: 8px; flex-shrink: 0; flex-wrap: wrap; }
.pf-btn { display: inline-flex; align-items: center; gap: 5px; padding: 7px 15px; border-radius: 8px; font-size: 12px; font-weight: 600; cursor: pointer; border: 1.5px solid transparent; transition: all .15s; text-decoration: none; white-space: nowrap; }
.pf-btn-primary { background: linear-gradient(135deg,#2563eb,#3b82f6); color: #fff; border-color: #2563eb; box-shadow: 0 2px 8px rgba(37,99,235,.25); }
.pf-btn-primary:hover { background: linear-gradient(135deg,#1d4ed8,#2563eb); }
.pf-btn-success { background: #fff; color: #16a34a; border-color: #86efac; }
.pf-btn-success:hover { background: #f0fdf4; border-color: #16a34a; }
.pf-btn-info { background: #fff; color: #0284c7; border-color: #bae6fd; }
.pf-btn-info:hover { background: #f0f9ff; border-color: #0284c7; }
.pf-btn-ghost { background: #f8fafc; color: #475569; border-color: #e2e8f0; }
.pf-btn-ghost:hover { background: #f1f5f9; }
.pf-btn-danger { background: #f43f5e; color: #fff; border-color: #f43f5e; }
.pf-btn-danger:hover { background: #e11d48; border-color: #e11d48; }
 
:deep(.vs__dropdown-toggle) { border: 1.5px solid #e2e8f0 !important; border-radius: 8px !important; min-height: 35px !important; padding: 0 8px !important; transition: border-color .15s, box-shadow .15s !important; }
:deep(.vs__dropdown-toggle:focus-within) { border-color: #3b82f6 !important; box-shadow: 0 0 0 3px rgba(59,130,246,.1) !important; }
:deep(.vs__search) { font-size: 12.5px !important; color: #1e293b !important; }
:deep(.vs__selected) { font-size: 12px !important; color: #1e293b !important; background: #eff6ff !important; border: 1px solid #bfdbfe !important; border-radius: 5px !important; }
</style>
 
 
<template>
 
<!-- ═══════════════════════════════════════════════
     ADD / EDIT PROFORMA INVOICE — FULLSCREEN MODAL
═══════════════════════════════════════════════ -->
<div class="modal fade" id="proforma_invoice_modal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-fullscreen" style="margin:0;">
    <div class="modal-content border-0 h-100" style="border-radius:0;">
 
      <div class="pf-main">
 
        <!-- Topbar -->
        <div class="pf-topbar">
          <div>
            <div class="pf-page-title">{{ id ? 'Edit Proforma Invoice' : 'Create New Proforma Invoice' }}</div>
            <div class="pf-page-sub">{{ id ? 'Update proforma invoice details below' : 'Fill in the details to generate a new proforma invoice' }}</div>
          </div>
          <div class="d-flex align-items-center gap-2">
            <button type="button" class="pf-btn pf-btn-ghost" @click="preview"><i class="ti ti-eye"></i> Preview</button>
            <button type="button" class="pf-close-btn" data-bs-dismiss="modal"><i class="ti ti-x"></i></button>
          </div>
        </div>
 
        <form @submit.prevent="submitProformaInvoice(false)" class="d-flex flex-column" style="flex:1;overflow:hidden;">
          <div class="pf-body">
 
            <!-- ── 1. Invoice Details ── -->
            <div class="pf-card">
              <div class="pf-card-head">
                <div class="pf-card-icon" style="background:#eff6ff;"><i class="ti ti-file-invoice" style="color:#3b82f6;"></i></div>
                <span class="pf-card-title">Invoice Details</span>
              </div>
              <div class="pf-card-body">
                <div class="row g-3">
                  <div class="col-md-3">
                    <label class="pf-label">Client Type <span class="req">*</span></label>
                    <select class="pf-select" v-model="party_type">
                      <option value="">Choose any</option>
                      <option value="App\Models\Lead" :selected="party_type === `App\\Models\\Lead`">Lead</option>
                      <option value="App\Models\Customer" :selected="party_type === `App\\Models\\Customer`">Customer</option>
                    </select>
                    <div v-if="errors.party_type" class="pf-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.party_type[0] }}</div>
                  </div>
                  <div class="col-md-5" v-if="party_type === `App\\Models\\Lead` || party_type === `App\\Models\\Customer`">
                    <label class="pf-label">Client <span class="req">*</span></label>
                    <vue-select v-model="selectedParty" :options="parties" :loading="loading" :filterable="false" @search="onSearch" @update:modelValue="onPartySelected" label="name" :placeholder="party_type === `App\\Models\\Lead` ? 'Search lead...' : 'Search customer...'"/>
                    <div v-if="errors.party_id" class="pf-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.party_id[0] }}</div>
                  </div>
                  <div class="col-md-4">
                    <label class="pf-label">Sales Person <span class="req">*</span></label>
                    <vue-select :options="users" label="name" placeholder="Select sales person" :reduce="u => u.id" v-model="sales_person_id"/>
                    <div v-if="errors.sales_person_id" class="pf-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.sales_person_id[0] }}</div>
                  </div>
                  <div class="col-md-2">
                    <label class="pf-label">Issue Date <span class="req">*</span></label>
                    <input type="date" class="pf-input" v-model="issue_date" />
                    <div v-if="errors.issue_date" class="pf-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.issue_date[0] }}</div>
                  </div>
                  <div class="col-md-2">
                    <label class="pf-label">Due Date <span class="req">*</span></label>
                    <input type="date" class="pf-input" v-model="due_date" />
                    <div v-if="errors.due_date" class="pf-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.due_date[0] }}</div>
                  </div>
                  <div class="col-md-2">
                    <label class="pf-label">Place of Supply</label>
                    <input type="text" class="pf-input" v-model="place_of_supply" />
                  </div>
                  <div class="col-md-3">
                    <label class="pf-label">Template</label>
                    <vue-select :options="templates" label="name" v-model="template" placeholder="Choose template"/>
                  </div>
                  <div class="col-md-2">
                    <label class="pf-label">Tax Mode <span class="req">*</span></label>
                    <vue-select :options="tax_modes" v-model="tax_mode"/>
                    <div v-if="errors.tax_mode" class="pf-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.tax_mode[0] }}</div>
                  </div>
                </div>
              </div>
            </div>
 
            <!-- ── Invoice-mode Tax ── -->
            <div class="pf-card" v-if="tax_mode == 'Invoice'">
              <div class="pf-card-head">
                <div class="pf-card-icon" style="background:#fffbeb;"><i class="ti ti-percent" style="color:#f59e0b;"></i></div>
                <span class="pf-card-title">Tax Information (Invoice Level)</span>
              </div>
              <div class="pf-card-body">
                <div class="row"><div class="col-md-4">
                  <label class="pf-label">Tax Rate</label>
                  <vue-select :options="taxes" label="name" placeholder="Select tax" v-model="selectedTax"/>
                  <div v-if="errors.tax_id" class="pf-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.tax_id[0] }}</div>
                </div></div>
              </div>
            </div>
 
            <!-- ── 2. Client Info ── -->
            <div class="pf-card">
              <div class="pf-card-head">
                <div class="pf-card-icon" style="background:#f0fdf4;"><i class="ti ti-user" style="color:#16a34a;"></i></div>
                <span class="pf-card-title">Client Information</span>
              </div>
              <div class="pf-card-body">
                <div class="row g-3">
                  <div class="col-lg-4"><label class="pf-label">To (Name)</label><input type="text" class="pf-input" v-model="to_name" /><div v-if="errors.to_name" class="pf-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.to_name[0] }}</div></div>
                  <div class="col-lg-4"><label class="pf-label">Email</label><input type="email" class="pf-input" v-model="to_email" /><div v-if="errors.to_email" class="pf-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.to_email[0] }}</div></div>
                  <div class="col-lg-2"><label class="pf-label">Phone</label><input type="text" class="pf-input" v-model="to_phone" /><div v-if="errors.to_phone" class="pf-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.to_phone[0] }}</div></div>
                  <div class="col-lg-2"><label class="pf-label">GST No</label><input type="text" class="pf-input" v-model="gst_no" /><div v-if="errors.gst_no" class="pf-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.gst_no[0] }}</div></div>
                </div>
              </div>
            </div>
 
            <!-- ── 3. Billing Address ── -->
            <div class="pf-card">
              <div class="pf-card-head">
                <div class="pf-card-icon" style="background:#fef3c7;"><i class="ti ti-map-pin" style="color:#f59e0b;"></i></div>
                <span class="pf-card-title">Billing Address</span>
              </div>
              <div class="pf-card-body">
                <div class="row g-3">
                  <div class="col-12"><label class="pf-label">Address</label><textarea class="pf-textarea" rows="2" v-model="to_address"></textarea><div v-if="errors.to_address" class="pf-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.to_address[0] }}</div></div>
                  <div class="col-md-3"><label class="pf-label">City</label><input type="text" class="pf-input" v-model="to_city" /><div v-if="errors.to_city" class="pf-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.to_city[0] }}</div></div>
                  <div class="col-md-2"><label class="pf-label">Zip Code</label><input type="text" class="pf-input" v-model="to_pincode" /></div>
                  <div class="col-md-3"><label class="pf-label">Country</label><vue-select v-model="to_country" :options="countries" label="name" placeholder="Select country" @update:modelValue="onCountrySelect"/></div>
                  <div class="col-md-3"><label class="pf-label">State</label><vue-select v-model="to_state" :options="states" label="name" placeholder="Select state"/></div>
                  <div class="col-md-1 d-flex align-items-end"><div class="form-check"><input class="form-check-input" type="checkbox" id="pf_is_shipping" v-model="is_shipping"><label class="form-check-label small" for="pf_is_shipping">Shipping</label></div></div>
                </div>
 
                <!-- Shipping Address -->
                <div class="row g-3 mt-3 pt-3 border-top" v-if="is_shipping">
                  <div class="col-12"><h6 style="font-size:11px;font-weight:700;color:#0284c7;text-transform:uppercase;letter-spacing:.5px;"><i class="ti ti-truck-delivery me-1"></i>Shipping Address</h6></div>
                  <div class="col-12"><label class="pf-label">Address</label><textarea class="pf-textarea" rows="2" v-model="to_shipping_address"></textarea></div>
                  <div class="col-md-3"><label class="pf-label">City</label><input type="text" class="pf-input" v-model="to_shipping_city" /></div>
                  <div class="col-md-2"><label class="pf-label">Zip Code</label><input type="text" class="pf-input" v-model="to_shipping_pincode" /></div>
                  <div class="col-md-3"><label class="pf-label">Country</label><vue-select v-model="to_shipping_country" :options="countries" label="name" placeholder="Select country" @update:modelValue="onShippingCountrySelect"/></div>
                  <div class="col-md-3"><label class="pf-label">State</label><vue-select v-model="to_shipping_state" :options="shipping_states" label="name" placeholder="Select state"/></div>
                </div>
              </div>
            </div>
 
            <!-- ── 4. Additional Details ── -->
            <div class="pf-card">
              <div class="pf-card-head">
                <div class="pf-card-icon" style="background:#f0fdf4;"><i class="ti ti-list-details" style="color:#16a34a;"></i></div>
                <span class="pf-card-title">Additional Details</span>
              </div>
              <div class="pf-card-body">
                <div class="row g-3">
                  <div class="col-md-3"><label class="pf-label">PO No.</label><input type="text" class="pf-input" v-model="po_number" /></div>
                  <div class="col-md-3"><label class="pf-label">PO Date</label><input type="date" class="pf-input" v-model="po_date" /></div>
                  <div class="col-md-3"><label class="pf-label">Vendor No.</label><input type="text" class="pf-input" v-model="vendor_number" /></div>
                  <div class="col-md-3"><label class="pf-label">Vehicle No.</label><input type="text" class="pf-input" v-model="vehicle_number" /></div>
                  <div class="col-md-3"><label class="pf-label">Subject</label><input type="text" class="pf-input" v-model="subject" placeholder="Enter subject" /></div>
                  <div class="col-md-3"><label class="pf-label">Transport Name</label><input type="text" class="pf-input" v-model="transport_name" /></div>
                  <div class="col-md-3"><label class="pf-label">Transport Phone</label><input type="text" class="pf-input" v-model="transport_phone" /></div>
                  <div class="col-md-3"><label class="pf-label">Customer Usage</label><input type="text" class="pf-input" v-model="customer_usage" /></div>
                </div>
              </div>
            </div>
 
            <!-- ── 5. Line Items ── -->
            <div class="pf-card">
              <div class="pf-card-head">
                <div class="pf-card-icon" style="background:#fffbeb;"><i class="ti ti-list-details" style="color:#f59e0b;"></i></div>
                <span class="pf-card-title">Invoice Line Items</span>
                <button type="button" class="pf-add-item-btn ms-auto" @click="addItemRow"><i class="ti ti-plus"></i> Add Item</button>
              </div>
              <div class="pf-card-body">
                <div v-for="(item, index) in items" :key="index" class="pf-item-card">
                  <div class="pf-item-num">{{ index + 1 }}</div>
                  <input type="hidden" v-model="item.hsn_code" />
                  <div class="row g-2 align-items-end">
                    <div :class="tax_mode === 'Item' ? 'col-md-3' : 'col-md-4'">
                      <label class="pf-label">Item</label>
                      <vue-select :options="allItems" label="name" v-model="item.item" :get-option-label="item => `${item.name} - ${item.code ?? item.id}`" @update:modelValue="val => onItemSelected(index, val)" placeholder="Select item"/>
                      <div class="pf-err-msg" v-if="getItemError(index, 'item_id')"><i class="ti ti-alert-circle"></i>{{ getItemError(index, 'item_id') }}</div>
                    </div>
                    <div class="col-md-2" v-if="tax_mode === 'Item'">
                      <label class="pf-label">Tax</label>
                      <vue-select :options="taxes" label="name" v-model="item.selectedTax" placeholder="Tax" @update:modelValue="val => onItemTaxSelected(index, val)"/>
                      <div class="pf-err-msg" v-if="getItemError(index, 'tax_id')"><i class="ti ti-alert-circle"></i>{{ getItemError(index, 'tax_id') }}</div>
                    </div>
                    <div class="col-md-2">
                      <label class="pf-label">Unit Cost</label>
                      <input type="number" class="pf-input" v-model.number="item.price" @input="updateAmount(index)" placeholder="0.00"/>
                      <div class="pf-err-msg" v-if="getItemError(index, 'unit_price')"><i class="ti ti-alert-circle"></i>{{ getItemError(index, 'unit_price') }}</div>
                    </div>
                    <div class="col-md-2">
                      <label class="pf-label">Unit</label>
                      <vue-select :options="units" v-model="item.selectedUnit" placeholder="Unit" @update:modelValue="val => onItemUnitSelected(index, val)"/>
                    </div>
                    <div class="col-md-1">
                      <label class="pf-label">Qty</label>
                      <input type="number" class="pf-input" v-model.number="item.qty" @input="updateAmount(index)" placeholder="1"/>
                      <div class="pf-err-msg" v-if="getItemError(index, 'quantity')"><i class="ti ti-alert-circle"></i>{{ getItemError(index, 'quantity') }}</div>
                    </div>
                    <div :class="tax_mode === 'Item' ? 'col-md-1' : 'col-md-2'">
                      <label class="pf-label">Amount</label>
                      <input type="text" class="pf-input" :value="getItemAmountDisplay(item).toFixed(2)" readonly style="background:#f8fafc;font-weight:700;color:#1e293b;" />
                    </div>
                    <div class="col-md-1 d-flex align-items-end">
                      <button type="button" class="pf-remove-btn" @click="removeItemRow(index)"><i class="ti ti-trash"></i></button>
                    </div>
                    <div class="col-12">
                      <label class="pf-label">Description</label>
                      <ckeditor :ref="`itemEditor${index}`" :editor="editor" v-model="item.description" :config="editorConfig" tag-name="textarea"/>
                    </div>
                  </div>
                </div>
                <div v-if="!items.length" style="text-align:center;padding:28px;color:#94a3b8;">
                  <i class="ti ti-inbox" style="font-size:28px;display:block;margin-bottom:6px;opacity:.4;"></i>No items added yet.
                </div>
              </div>
            </div>
 
            <!-- ── 6. Notes & Terms ── -->
            <div class="pf-card">
              <div class="pf-card-head">
                <div class="pf-card-icon" style="background:#faf5ff;"><i class="ti ti-notes" style="color:#8b5cf6;"></i></div>
                <span class="pf-card-title">Terms & Notes</span>
              </div>
              <div class="pf-card-body">
                <div class="row g-3">
                  <div class="col-md-6">
                    <label class="pf-label">Terms & Conditions</label>
                    <ckeditor :editor="editor" v-model="settings.terms" :config="editorConfig"></ckeditor>
                    <div class="pf-err-msg" v-if="errors.terms"><i class="ti ti-alert-circle"></i>{{ errors.terms[0] }}</div>
                  </div>
                  <div class="col-md-6">
                    <label class="pf-label">Internal Notes</label>
                    <ckeditor :editor="editor" v-model="notes" :config="editorConfig"></ckeditor>
                    <div class="pf-err-msg" v-if="errors.notes"><i class="ti ti-alert-circle"></i>{{ errors.notes[0] }}</div>
                  </div>
                </div>
              </div>
            </div>
 
            <!-- ── 7. Pricing Summary ── -->
            <div class="pf-card">
              <div class="pf-card-head">
                <div class="pf-card-icon" style="background:#f0fdf4;"><i class="ti ti-calculator" style="color:#16a34a;"></i></div>
                <span class="pf-card-title">Pricing Summary</span>
              </div>
              <div class="pf-card-body">
                <div style="max-width:400px;margin-left:auto;">
                  <div class="pf-price-row">
                    <span class="pf-price-label">Subtotal</span>
                    <span class="pf-price-val">{{ currency }} {{ totalAmount.toFixed(2) }}</span>
                  </div>
                  <div class="pf-price-row" v-if="showTaxInfo && taxAmount">
                    <span class="pf-price-label">{{ tax_mode === 'Invoice' ? 'Tax — ' + selectedTax?.name : 'Item Taxes' }}</span>
                    <span class="pf-price-val" style="color:#2563eb;">{{ currency }} {{ taxAmount.toFixed(2) }}</span>
                  </div>
                  <div class="pf-price-row">
                    <label class="pf-price-label mb-0">Discount</label>
                    <div class="pf-price-input-box"><span class="pf-price-prefix">{{ currency || '₹' }}</span><input type="number" min="0" class="pf-price-num-input" v-model.number="discount" /></div>
                  </div>
                  <div class="pf-price-row">
                    <label class="pf-price-label mb-0">Transportation</label>
                    <div class="pf-price-input-box"><span class="pf-price-prefix">{{ currency || '₹' }}</span><input type="number" min="0" class="pf-price-num-input" v-model.number="transportation_cost" /></div>
                  </div>
                  <div class="pf-price-row">
                    <label class="pf-price-label mb-0">Installation</label>
                    <div class="pf-price-input-box"><span class="pf-price-prefix">{{ currency || '₹' }}</span><input type="number" min="0" class="pf-price-num-input" v-model.number="installation_cost" /></div>
                  </div>
                  <div class="pf-price-row" v-if="!id">
                    <label class="pf-price-label mb-0">Advance Amount</label>
                    <div class="pf-price-input-box"><span class="pf-price-prefix">{{ currency || '₹' }}</span><input type="number" min="0" class="pf-price-num-input" v-model.number="advance_amount" /></div>
                  </div>
                  <div class="pf-grand-box">
                    <div class="pf-grand-label"><i class="ti ti-check" style="font-size:13px;"></i> Grand Total</div>
                    <span class="pf-grand-val">{{ currency }} {{ grandTotal.toFixed(2) }}</span>
                  </div>
                  <div class="pf-balance-box">
                    <div class="pf-balance-label"><i class="ti ti-alert-triangle" style="font-size:13px;"></i> Balance Due</div>
                    <span class="pf-balance-val">{{ currency }} {{ balanceAmount.toFixed(2) }}</span>
                  </div>
                </div>
              </div>
            </div>
 
          </div><!-- /pf-body -->
 
          <!-- Footer -->
          <div class="pf-footer">
            <button type="button" class="pf-btn pf-btn-ghost me-auto" @click="addItemRow"><i class="ti ti-plus"></i> Add Item</button>
            <button type="button" class="pf-btn pf-btn-info" @click="preview"><i class="ti ti-eye"></i> Preview</button>
            <button type="button" class="pf-btn pf-btn-success" @click="saveAndDownload"><i class="ti ti-download"></i> Save & Download</button>
            <button type="button" class="pf-btn pf-btn-info" @click="saveAndSend" v-if="settings?.send_on_email"><i class="ti ti-send"></i> Save & Send</button>
            <button type="button" class="pf-btn pf-btn-primary" @click="save"><i class="ti ti-device-floppy"></i> Save</button>
          </div>
        </form>
      </div>
 
    </div>
  </div>
</div>
<!-- /ADD PROFORMA INVOICE MODAL -->
 
 
<!-- ═══════════════════════════════════════════════
     DELETE MODAL
═══════════════════════════════════════════════ -->
<div class="modal fade" id="proforma_invoice_delete_modal">
<div class="modal-dialog modal-dialog-centered">
<div class="modal-content" style="border:none;border-radius:16px;overflow:hidden;">
<div class="modal-body" style="padding:32px 24px;text-align:center;">
  <div style="width:60px;height:60px;background:#fff0f3;border-radius:14px;display:flex;align-items:center;justify-content:center;margin:0 auto 16px;">
    <i class="ti ti-trash-x" style="font-size:26px;color:#f43f5e;"></i>
  </div>
  <h4 style="font-weight:700;color:#0f172a;margin-bottom:8px;">Delete Proforma Invoice?</h4>
  <p style="color:#64748b;font-size:13px;margin-bottom:24px;">This action cannot be undone. The invoice will be permanently removed.</p>
  <div class="d-flex justify-content-center gap-3">
    <a href="javascript:void(0);" class="pf-btn pf-btn-ghost" data-bs-dismiss="modal">Cancel</a>
    <a href="javascript:void(0);" class="pf-btn pf-btn-danger" @click="deleteProformaInvoice"><i class="ti ti-trash"></i> Yes, Delete</a>
  </div>
</div>
</div>
</div>
</div>
 
 
<!-- ═══════════════════════════════════════════════
     ASSIGN MODAL
═══════════════════════════════════════════════ -->
<div class="modal fade" id="proforma_invoice_assign_modal">
<div class="modal-dialog modal-dialog-centered modal-lg">
<div class="modal-content" style="border:none;border-radius:16px;overflow:hidden;">
<div class="modal-header" style="background:#f8fafc;border-bottom:1px solid #e2e8f0;padding:13px 18px;">
  <h4 class="modal-title" style="font-size:14px;font-weight:700;color:#0f172a;">{{ modal_title }}</h4>
  <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close"><i class="ti ti-x"></i></button>
</div>
<form @submit.prevent="assignProformaInvoice">
  <div class="modal-body" style="padding:18px;">
    <div class="row g-3">
      <div class="col-md-4">
        <label class="pf-label">Assign To</label>
        <select class="pf-select" v-model="user_id"><option v-for="row in users" :key="row.id" :value="row.id">{{ row.name }}</option></select>
        <div v-if="errors.user_id" class="pf-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.user_id[0] }}</div>
      </div>
      <div class="col-md-6">
        <label class="pf-label">Remark</label>
        <input type="text" class="pf-input" v-model="remark" placeholder="Add a note..." />
        <div v-if="errors.remark" class="pf-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.remark[0] }}</div>
      </div>
      <div class="col-md-2 d-flex align-items-end"><button type="submit" class="pf-btn pf-btn-primary w-100">Assign</button></div>
    </div>
  </div>
  <div class="modal-footer" style="border-top:1px solid #e2e8f0;padding:14px 18px;flex-direction:column;align-items:stretch;">
    <table class="table table-sm mb-0" style="font-size:12px;" v-if="assignment_history.length">
      <thead style="background:#f8fafc;">
        <tr><th style="font-weight:600;color:#64748b;">#</th><th style="font-weight:600;color:#64748b;">By</th><th style="font-weight:600;color:#64748b;">From</th><th style="font-weight:600;color:#64748b;">To</th><th style="font-weight:600;color:#64748b;">Status</th><th style="font-weight:600;color:#64748b;">Remark</th><th style="font-weight:600;color:#64748b;">Date</th></tr>
      </thead>
      <tbody>
        <tr v-for="(row, index) in assignment_history" :key="row.id">
          <td>{{ index + 1 }}</td><td>{{ row.assign_by.name }}</td><td>{{ row.assign_from.name }}</td><td>{{ row.assign_to.name }}</td>
          <td><span style="padding:2px 8px;background:#f0fdf4;color:#16a34a;border-radius:20px;font-size:10px;font-weight:600;">{{ row.status }}</span></td>
          <td>{{ row.remark }}</td><td>{{ $formatDate(row.created_at, 'DD-MM-YY, hh:mm a') }}</td>
        </tr>
      </tbody>
    </table>
    <div v-else style="text-align:center;padding:14px;color:#94a3b8;font-size:13px;">No assignment history.</div>
  </div>
</form>
</div>
</div>
</div>
 
 
<!-- ═══════════════════════════════════════════════
     ACTIVITY MODAL
═══════════════════════════════════════════════ -->
<div class="modal fade" id="quotation_activity_modal">
<div class="modal-dialog modal-dialog-centered">
  <div class="modal-content" style="border:none;border-radius:16px;overflow:hidden;">
    <div class="modal-header" style="background:#f8fafc;border-bottom:1px solid #e2e8f0;padding:13px 18px;">
      <h4 class="modal-title" style="font-size:14px;font-weight:700;color:#0f172a;">Activity Log</h4>
      <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close"><i class="ti ti-x"></i></button>
    </div>
    <div class="modal-body" style="padding:18px;">
      <div v-if="activities.length">
        <div v-for="row in activities" :key="row.id" style="display:flex;align-items:flex-start;gap:12px;padding:10px 0;border-bottom:1px dashed #f1f5f9;">
          <div style="width:34px;height:34px;background:#fffbeb;border-radius:9px;display:flex;align-items:center;justify-content:center;flex-shrink:0;">
            <i class="ti ti-circle-dot" style="color:#f59e0b;font-size:13px;"></i>
          </div>
          <div>
            <p style="margin:0 0 3px;font-size:12.5px;color:#1e293b;font-weight:500;">{{ row.description }}</p>
            <p style="margin:0;font-size:11px;color:#94a3b8;"><i class="ti ti-clock-hour-3" style="margin-right:3px;"></i>{{ $formatDate(row.created_at, 'DD MMM YYYY, hh:mm a') }}</p>
          </div>
        </div>
      </div>
      <div v-else style="text-align:center;padding:28px;color:#94a3b8;">
        <i class="ti ti-history" style="font-size:28px;display:block;margin-bottom:6px;opacity:.4;"></i>No activity recorded yet.
      </div>
    </div>
  </div>
</div>
</div>
 
 
<!-- ═══════════════════════════════════════════════
     BULK ACTION MODAL
═══════════════════════════════════════════════ -->
<div class="modal fade" id="bulk_action_proforma_invoice">
<div class="modal-dialog modal-dialog-centered">
  <div class="modal-content" style="border:none;border-radius:16px;overflow:hidden;">
    <div class="modal-header" style="background:#f8fafc;border-bottom:1px solid #e2e8f0;padding:13px 18px;">
      <h4 class="modal-title" style="font-size:14px;font-weight:700;color:#0f172a;">Bulk Actions</h4>
      <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close"><i class="ti ti-x"></i></button>
    </div>
    <form @submit.prevent="submitBulkAction">
      <div class="modal-body" style="padding:18px;">
        <div style="display:flex;align-items:center;gap:10px;padding:12px 14px;background:#fff0f3;border:1px solid #fecdd3;border-radius:10px;">
          <input type="checkbox" class="form-check-input" name="mass_delete" id="mass_delete_pf" v-model="mass_delete" style="width:15px;height:15px;accent-color:#f43f5e;flex-shrink:0;margin-top:0;" />
          <div>
            <label for="mass_delete_pf" style="font-size:12.5px;font-weight:600;color:#991b1b;cursor:pointer;margin:0;">Mass Delete</label>
            <div style="font-size:11px;color:#f87171;">Permanently remove all selected invoices</div>
          </div>
        </div>
      </div>
      <div class="modal-footer" style="border-top:1px solid #e2e8f0;padding:11px 18px;gap:8px;">
        <button type="button" class="pf-btn pf-btn-ghost" data-bs-dismiss="modal">Cancel</button>
        <button type="submit" class="pf-btn pf-btn-primary">Confirm</button>
      </div>
    </form>
  </div>
</div>
</div>
 
 
<!-- ═══════════════════════════════════════════════
     MAIL MODAL
═══════════════════════════════════════════════ -->
<div class="modal fade" id="proforma_mail_modal">
<div class="modal-dialog modal-dialog-centered modal-lg">
  <div class="modal-content" style="border:none;border-radius:16px;overflow:hidden;">
    <div class="modal-header" style="background:linear-gradient(135deg,#0f172a,#1e3a5f);padding:15px 20px;border:none;">
      <div>
        <h4 class="modal-title" style="font-size:14px;font-weight:700;color:#fff;margin:0;">{{ modal_title }}</h4>
        <div style="font-size:11px;color:#64748b;margin-top:1px;">Send this proforma invoice via email</div>
      </div>
      <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close" style="filter:invert(1);opacity:.6;"><i class="ti ti-x"></i></button>
    </div>
    <form @submit.prevent="sendMail">
     <div class="modal-body" style="padding:20px;">
      <div class="mb-3"><DocumentPlaceholder/></div>
      <div class="mb-3">
        <label class="pf-label">To Email</label>
        <input type="text" class="pf-input" v-model="to_email" placeholder="recipient@email.com" />
        <div class="pf-err-msg" v-if="errors.to_email"><i class="ti ti-alert-circle"></i>{{ errors.to_email[0] }}</div>
      </div>
      <div class="mb-3">
        <label class="pf-label">Email Subject</label>
        <input type="text" class="pf-input" v-model="settings.mail_subject" />
        <div class="pf-err-msg" v-if="errors.mail_subject"><i class="ti ti-alert-circle"></i>{{ errors.mail_subject[0] }}</div>
      </div>
      <div class="mb-3">
        <label class="pf-label">Email Body</label>
        <ckeditor :editor="editor" v-model="settings.mail_body" :config="editorConfig"></ckeditor>
        <div class="pf-err-msg" v-if="errors.mail_body"><i class="ti ti-alert-circle"></i>{{ errors.mail_body[0] }}</div>
      </div>
      <div class="mb-3">
        <label class="pf-label">Email Footer</label>
        <ckeditor :editor="editor" v-model="settings.mail_footer" :config="editorConfig"></ckeditor>
        <div class="pf-err-msg" v-if="errors.mail_footer"><i class="ti ti-alert-circle"></i>{{ errors.mail_footer[0] }}</div>
      </div>
     </div>
     <div class="modal-footer" style="border-top:1px solid #e2e8f0;padding:11px 20px;gap:8px;">
      <button type="button" class="pf-btn pf-btn-ghost" data-bs-dismiss="modal">Cancel</button>
      <button type="submit" class="pf-btn pf-btn-primary"><i class="ti ti-send"></i> Send Email</button>
     </div>
    </form>
  </div>
</div>
</div>
 
</template>